<app-example-format
  [title]="componentInfo.title"
  urlTSDocs="https://docs.kadaster.nl/ggc/ggs-ggc-library/tsdocs/classes/ggc-layer-image_src_lib_layer-image_ggc-layer-image.component.GgcSearchLocationComponent.html"
  urlVoorbeelden=""
  urlChangelog=""
  [codeHtmlPath]="'code/examples/example-layer/example-layer-geojson-ogc/example-layer-geojson-ogc.component.html'"
  [codeTypescriptPath]="'code/examples/example-layer/example-layer-geojson-ogc/example-layer-geojson-ogc.component.ts'"
  [codeScssPath]="'code/examples/example-layer/example-layer-geojson-ogc/example-layer-geojson-ogc.component.scss'"
  urlCodeHtml="example-snapping/example-layer-geojson-ogc/example-layer-geojson-ogc.component.html"
  urlCodeTypescript="example-snapping/example-layer-geojson-ogc/example-layer-geojson-ogc.component.ts"
  urlCodeScss="example-snapping/example-layer-geojson-ogc/example-layer-geojson-ogc.component.scss"
>
  @if (componentInfo.tags && componentInfo.tags?.length > 0) {
    <div page-labels>
      @for (tag of componentInfo.tags; track tag) {
        <span class="badge bg-primary mx-1">{{ tag.toLocaleLowerCase() }}</span>
      }
    </div>
  }

  <div page-introduction>
    <p>
      {{ componentInfo.introduction }}
    </p>
    <p>
      In het voorbeeld hieronder is een GeoJSON OCG API-kaart met buurten in de
      omgeving van Apeldoorn als laag toegevoegd aan de kaart.
    </p>
  </div>

  <div page-functionality>
    <!-- DOCS:START functionality -->
    <div class="map-container">
      <ggc-map>
        <ggc-layer-brt-achtergrondkaart></ggc-layer-brt-achtergrondkaart>
        <ggc-geojson-layer [options]="optionsBuurt"></ggc-geojson-layer>
      </ggc-map>
    </div>
    <!-- DOCS:END functionality -->
  </div>
</app-example-format>
